import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import heroImage from "../assets/designer-3-WD0z7WdoTv2Nm7zB.avif";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__blob hero__blob--a" aria-hidden="true" />
      <div className="hero__blob hero__blob--b" aria-hidden="true" />

      <div className="hero__container">
        <div className="hero__content">
          <h1 className="hero__title">
            Contabilidade, controladoria
            e estratégia para{" "}
            <span className="hero__title-highlight">Factoring, Securitizadora de Crédito e
              Empresas Prestadoras de
              Serviços em geral</span>
          </h1>

          <p className="hero__text">
            Soluções completas nas áreas Fiscal, Legal e Contábil para manter
            sua empresa organizada, regularizada e preparada para crescer.
          </p>

          <div className="hero__actions">
            <Link to="/contato" className="hero__button hero__button--primary">
              Fale com um Especialista
            </Link>
            <Link to="/servicos" className="hero__button hero__button--secondary">
              Conheça Nossos Serviços
            </Link>
          </div>
        </div>

        <div className="hero__media">
          <div className="hero__media-shape">
            <img
              src={heroImage}
              alt="Especialista da Eniato Contabilidade"
              className="hero__image"
            />
          </div>

          <div className="hero__badge">
            <span className="hero__badge-icon" aria-hidden="true">✓</span>
            <span className="hero__badge-text">Atendimento Consultivo</span>
          </div>
        </div>
      </div>
    </section>
  );
}
